import { action } from 'satcheljs';
import type HeaderCharmType from '../store/schema/HeaderCharmType';

export interface ToggleCharmActionMessage {
    charm: HeaderCharmType;
}

const defaultExport: (charm: HeaderCharmType) => ToggleCharmActionMessage = action(
    'TOGGLE_CHARM',
    function toggleCharm(charm: HeaderCharmType): ToggleCharmActionMessage {
        return {
            charm,
        };
    }
);
export default defaultExport;
